import Request from './request';
import request_configs from "./request_configs";

async function fetch(data) {
    request_configs.Headers['access-token'] = localStorage.getItem('accessToken')
    return Request(
        'post',
        request_configs.AdminUrl + 'api/accounts-qacenter/get-question-detail',
        data,
        false,
        false,
        false,
        request_configs.Headers
    )
}

async function fetchList(data) {
    request_configs.Headers['access-token'] = localStorage.getItem('accessToken')
    return Request(
        'post',
        request_configs.AdminUrl + 'api/accounts-qacenter/get-questions-list',
        data,
        false,
        false,
        false,
        request_configs.Headers
    )
}

async function newQaSave(data) {
    request_configs.Headers['access-token'] = localStorage.getItem('accessToken')
    return Request(
        'post',
        request_configs.AdminUrl + 'api/accounts-qacenter/new-qa-save',
        data,
        false,
        false,
        false,
        request_configs.Headers
    )
}

async function newAnswerSave(data) {
    request_configs.Headers['access-token'] = localStorage.getItem('accessToken')
    return Request(
        'post',
        request_configs.AdminUrl + 'api/accounts-qacenter/new-answer-save',
        data,
        false,
        false,
        false,
        request_configs.Headers
    )
}


export default {
    fetch,
    fetchList,
    newQaSave,
    newAnswerSave
}
